export default (sectionName, metricKey, diff) => {
  let lessIsGood = false;
  const metric = metricKey.toLowerCase();
  if (metric.includes("cpc")) {
    lessIsGood = true;
  } else if (metric.includes("cpa")) {
    lessIsGood = true;
  } else if (metric.includes("spend") && sectionName == "goalsAndProjections") {
    lessIsGood = true;
  } else if (metric.includes("bounce_rate")) {
    lessIsGood = true;
  } else if (metric.includes("cpv")) {
    lessIsGood = true;
  }
  
  const negative = lessIsGood ? diff >= 0 : diff < 0;

  return negative;
};
